export default __webpack_public_path__ + "static/proximanova-bold-woff2-1111aa5a686b4f127b7272e21cbdcccb.woff2";